import React from "react";
import classNames from "classnames/bind";

import styles from "./Radio.module.css";

const cx = classNames.bind(styles);

type Props = Omit<React.HTMLProps<HTMLInputElement>, "type" | "className">;

export const Radio: React.FC<Props> = (props) => {
  const { children, ...rest } = props;

  return (
    <label className={cx("radio")}>
      <input {...rest} className={cx("input")} type="radio" />
      <div className={cx("label")}>{children}</div>
    </label>
  );
};
